import { JSONSchemaType } from 'ajv'

export interface ILetterOfAttorneyEsocialFormData {
  cnpjConducco: string
  acceptance: boolean
}

const LetterOfAttorneyEsocialSchema: JSONSchemaType<ILetterOfAttorneyEsocialFormData> = {
  type: 'object',
  properties: {
    cnpjConducco: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Este campo não pode estar em branco.',
    },
    acceptance: {
      type: 'boolean',
      errorMessage: 'Você deve aceitar os termos!',
    },
  },
  required: ['cnpjConducco', 'acceptance'],
  additionalProperties: false,
}

export default LetterOfAttorneyEsocialSchema
